import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=788e124f&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e124f",
  null
  
)

component.options.__file = "couponList.vue"
export default component.exports